export default () => {
    digitalData.page.attributes.sephoraPageInfo.pageName = 'questions&answers:unsubscribe-request:n/a:*';
};
